import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// dynamic
const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            component: m => import('../views/index.vue').then(m => m.default)
        },
        {
            path: '*',
            redirect: '/index'
        }
    ]
});

/**
 * 添加二级菜单跳转
 */
window.toRoutePath = function (path) {
    router.push({ path: path });
};

export default router;
